import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SessionStorage from 'libs/SessionStorage';
import OidcService from 'services/OidcService';
import { AppCatalog } from 'modules/Account';
import { LogoLayout } from 'modules/Layout';
async function action({ route }) {
    let Component = null;
    let externalRedirect = null;
    let redirect = null;
    let isAuthenticated = false;
    if (process.env.BROWSER) {
        const user = await OidcService.getUser();
        if (user) {
            const blsReturnUrl = SessionStorage.getItem('blsReturnUrl') || SessionStorage.getItem('hardBlsReturnUrl');
            const returnPath = SessionStorage.getItem('returnPath');
            if (returnPath) {
                SessionStorage.removeItem('returnPath');
                redirect = returnPath;
            } else if (blsReturnUrl) {
                SessionStorage.removeItem('blsReturnUrl');
                SessionStorage.removeItem('hardBlsReturnUrl');
                externalRedirect = blsReturnUrl;
            } else {
                isAuthenticated = true;
                Component = /*#__PURE__*/ _jsx(AppCatalog, {});
            }
        } else {
            await OidcService.login();
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        externalRedirect,
        component: /*#__PURE__*/ _jsx(LogoLayout, {
            isAuthenticated: isAuthenticated,
            children: Component
        })
    };
}
export default action;
